var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanAreaBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1110 1110",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 0C19.2518 0 0 19.2517 0 43V1067C0 1090.75 19.2517 1110 43 1110H1067C1090.75 1110 1110 1090.75 1110 1067V43C1110 19.2518 1090.75 0 1067 0H43ZM40 22C30.0589 22 22 30.0589 22 40V1070C22 1079.94 30.0589 1088 40 1088H1070C1079.94 1088 1088 1079.94 1088 1070V40C1088 30.0589 1079.94 22 1070 22H40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanAreaBorder);
export default __webpack_public_path__ + "static/media/scan-area-border.9c3311841095d88c9483ce348203bf29.svg";
export { ForwardRef as ReactComponent };